<template>
  <div>
    <sticky-header
      v-if="title"
      :anchor="anchor"
    >
      {{ title }}
    </sticky-header>
    <q-markup-table>
      <thead>
        <tr>
          <th
            v-for="(header, key) in headers"
            :key="key"
            :style="{width: header.width || undefined}"
            class="text-left"
            v-html="header.html"
          />
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(row, key) in rows"
          :key="key"
        >
          <td
            v-for="(cell, cKey) in row"
            :key="key + '-' + cKey"
            :colspan="cell.colspan"
            v-html="cell.html"
          />
        </tr>
      </tbody>
    </q-markup-table>
  </div>
</template>

<script>
/**
 * InfoTable is a generic table containing a payload sent from the backend
 * (formatted using TableBuiler)
 */
export default {
  props: {
    // Title of the table
    title: {
      type: String
    },
    // Headers of the table
    headers: {
      required: true,
      type: Array
    },
    // Rows in the table body
    rows: {
      required: true,
      type: Array
    },
    // if a title is supplied, the title will remain sticky to the top of either: page,dialog,none
    anchor: {
      type: String,
      default: 'page'
    }
  }
}
</script>
